import {
  IExternalDataObjectStyleConfiguration,
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";
import {
  PaintStyle,
  TextStyle,
} from "../../../../domain/drawing";
import {
  ExternalDataItem,
} from "../../../../domain/document/items";
import { AbstractTextObjectStyleReader } from "./AbstractTextObjectStyleReader";

export class ExternalDataObjectStyleReader extends AbstractTextObjectStyleReader<ExternalDataItem> {
  constructor(private readonly _configuration: IExternalDataObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: ExternalDataItem, shouldInputFree: boolean): PaintStyle {
    return source.paintStyleOnEditing;
  }

  protected readBackgroundColorConfiguration(source: ExternalDataItem, shouldInputFree: boolean): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  protected readBorderColorConfiguration(source: ExternalDataItem, shouldInputFree: boolean): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  private readObjectStyleConfiguration(source: ExternalDataItem, shouldInputFree: boolean): IObjectColorConfiguration {
    return (source.shouldInputFree || (source.isFreeInputable && shouldInputFree))
      ? this._configuration.default
      : this._configuration.externalData;
  }

  public readTextStyle(source: ExternalDataItem, shouldInputFree: boolean, isFocused: boolean): TextStyle {
    if (source.shouldInputFree || (source.isFreeInputable && shouldInputFree)) {
      return isFocused
        ? this.toFreeInputTextStyle(source)
        : this.toTextStyle(source);
    } else if (source.isEmpty) {
      return this.toObjectNameTextStyle(source);
    }
    return this.toTextStyle(source);
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return this._configuration.foreground;
  }
}
